export const calculateThemesStyle = themeClass => {
  switch (themeClass) {
    case 'theme-class-01':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Poppins',
        background_color: '#265eb9',
        button_color: '#ffffff',
        button_font_color: '#1d3548',
        button_style: 'button-style-01',
        button_thumbnail_style: 'button-thumbnail-style-02',
        button_border_color: '#ffffff',
        background_gradient: 'linear-gradient(45deg, #110a7b, #308fdf)',
        font_color: '#ffffff',
        social_icon_color: '#ffffff',
      };
    case 'theme-class-02':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Poppins',
        background_color: '#c069d1',
        button_color: '#ffffff',
        button_font_color: '#1d3548',
        button_style: 'button-style-02',
        button_thumbnail_style: 'button-thumbnail-style-03',
        button_border_color: '#ffffff',
        background_gradient: 'linear-gradient(135deg, #ff6cab, #7366ff)',
        font_color: '#ffffff',
        social_icon_color: '#ffffff',
      };
    case 'theme-class-03':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Poppins',
        background_color: '#9ca0cf',
        button_color: '#ffffff',
        button_font_color: '#1d3548',
        button_style: 'button-style-03',
        button_thumbnail_style: 'button-thumbnail-style-01',
        button_border_color: '#ffffff',
        background_gradient: 'linear-gradient(135deg, #64e8de, #8a64eb)',
        font_color: '#ffffff',
        social_icon_color: '#ffffff',
      };
    case 'theme-class-04':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Cabin',
        background_color: '#75aee4',
        button_color: '#ffffff',
        button_font_color: '#1d3548',
        button_style: 'button-style-01',
        button_thumbnail_style: 'button-thumbnail-style-03',
        button_border_color: '#604476',
        background_gradient: 'linear-gradient(135deg, #b65eba, #7bf2e9)',
        font_color: '#583c69',
        social_icon_color: '#583c69',
      };
    case 'theme-class-05':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Quicksand',
        background_color: '#c687b9',
        button_color: '#ffffff',
        button_font_color: '#401428',
        button_style: 'button-style-01',
        button_thumbnail_style: 'button-thumbnail-style-01',
        button_border_color: '#ffffff',
        background_gradient: 'linear-gradient(135deg, #ff9482, #7d77ff)',
        font_color: '#822448',
        social_icon_color: '#ffffff',
      };
    case 'theme-class-06':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Poppins',
        background_color: '#ffac1b',
        button_color: '#ffac1b',
        button_font_color: '#1d3548',
        button_style: 'button-style-06',
        button_thumbnail_style: 'button-thumbnail-style-02',
        button_border_color: '#1d3548',
        background_gradient: 'linear-gradient(135deg, #ffcf1b, #ff881b)',
        font_color: '#1d3548',
        social_icon_color: '#1d3548',
      };
    case 'theme-class-07':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Poppins',
        background_color: '#f3752d',
        button_color: '#f3752d',
        button_font_color: '#ffffff',
        button_style: 'button-style-07',
        button_thumbnail_style: 'button-thumbnail-style-03',
        button_border_color: '#ffffff',
        background_gradient: 'linear-gradient(135deg, #ea4d2c, #ffa62e)',
        font_color: '#ffffff',
        social_icon_color: '#ffffff',
      };
    case 'theme-class-08':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Poppins',
        background_color: '#00e0d7',
        button_color: '#00e0d7',
        button_font_color: '#086764',
        button_style: 'button-style-08',
        button_thumbnail_style: 'button-thumbnail-style-01',
        button_border_color: '#086764',
        background_gradient: 'linear-gradient(135deg, #00ffed, #00b8ba)',
        font_color: '#086764',
        social_icon_color: '#086764',
      };
    case 'theme-class-09':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Londrina Solid',
        background_color: '#69a2f3',
        button_color: '#ffffff',
        button_font_color: '#1d3548',
        button_style: 'button-style-04',
        button_thumbnail_style: 'button-thumbnail-style-01',
        button_border_color: '#7dd9e8',
        background_gradient: 'linear-gradient(135deg, #6ee2f5, #6454f0)',
        font_color: '#3d408e',
        social_icon_color: '#ffffff',
      };
    case 'theme-class-10':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Montserrat',
        background_color: '#376dc7',
        button_color: '#ffffff',
        button_font_color: '#000000',
        button_style: 'button-style-05',
        button_thumbnail_style: 'button-thumbnail-style-02',
        button_border_color: '#188ff9',
        background_gradient: 'linear-gradient(135deg, #3499ff, #3a3985)',
        font_color: '#ffffff',
        social_icon_color: '#ffffff',
      };
    case 'theme-class-11':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Open Sans',
        background_color: '#f68d82',
        button_color: '#ffe0c8',
        button_font_color: '#000000',
        button_style: 'button-style-11',
        button_thumbnail_style: 'button-thumbnail-style-02',
        button_border_color: '#f74256',
        background_gradient: 'linear-gradient(135deg, #ffcda5, #ee4d5f)',
        font_color: '#f84256',
        social_icon_color: '#ffdbc3',
      };
    case 'theme-class-12':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Prosto One',
        background_color: '#9f5bda',
        button_color: '#ffffff',
        button_font_color: '#1d3548',
        button_style: 'button-style-14',
        button_thumbnail_style: 'button-thumbnail-style-03',
        button_border_color: '#ffffff',
        background_gradient: 'linear-gradient(135deg, #5650de, #f869d5)',
        font_color: '#ffffff',
        social_icon_color: '#ffffff',
      };
    case 'theme-class-13':
      return {
        // avatar_style: 'avatar-style-01',
        font_style: 'Merienda',
        background_color: '#bb0758',
        button_color: '#ffffff',
        button_font_color: '#4f1229',
        button_style: 'button-style-15',
        button_thumbnail_style: 'button-thumbnail-style-01',
        button_border_color: '#ffc7d8',
        background_gradient: 'linear-gradient(135deg, #f00b51, #780161)',
        font_color: '#ffbfd2',
        social_icon_color: '#ffbfd2',
      };
    default:
      return null;
  }
};
